import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import RetroButton from '../../components/ui/RetroButton';

const ReserveModal = ({ slot, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    businessName: '',
    industry: '',
    contactName: '',
    email: '',
    phone: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!slot) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      onSubmit(slot);
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-retro-brown/80 p-4 backdrop-blur-sm">
      <div className="bg-retro-cream border-4 border-retro-brown rounded-[2rem] p-8 max-w-md w-full shadow-[16px_16px_0px_0px_rgba(58,44,39,1)] relative animate-in fade-in zoom-in duration-200">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 bg-white border-4 border-retro-brown rounded-full flex items-center justify-center hover:bg-retro-yellow transition-colors"
        >
          <SafeIcon name="X" className="text-xl" />
        </button>

        <div className="mb-6">
          <div className="inline-block bg-retro-teal text-white font-display text-[10px] px-3 py-1 rounded-full uppercase tracking-widest border-2 border-retro-brown mb-2">
            Pledge Reservation • {slot.cityName}
          </div>
          <h2 className="font-display text-3xl uppercase tracking-tighter leading-none mb-2">
            Reserve <span className="text-retro-blue">{slot.label}</span>
          </h2>
          <p className="font-body font-bold text-gray-600 text-xs">
            Submit your info to lock in this space. Our team will contact you to finalize the design.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block font-body font-bold text-xs mb-1">Business Name</label>
            <input required type="text" name="businessName" value={formData.businessName} onChange={handleChange} className="w-full border-4 border-retro-brown rounded-xl p-2.5 font-body bg-white focus:outline-none focus:border-retro-teal text-sm" placeholder="e.g. West Valley Plumbing" />
          </div>
          <div>
            <label className="block font-body font-bold text-xs mb-1">Industry / Trade</label>
            <input required type="text" name="industry" value={formData.industry} onChange={handleChange} className="w-full border-4 border-retro-brown rounded-xl p-2.5 font-body bg-white focus:outline-none focus:border-retro-teal text-sm" placeholder="e.g. Home Services" />
          </div>
          <div>
            <label className="block font-body font-bold text-xs mb-1">Contact Name</label>
            <input required type="text" name="contactName" value={formData.contactName} onChange={handleChange} className="w-full border-4 border-retro-brown rounded-xl p-2.5 font-body bg-white focus:outline-none focus:border-retro-teal text-sm" placeholder="John Doe" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-body font-bold text-xs mb-1">Email</label>
              <input required type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border-4 border-retro-brown rounded-xl p-2.5 font-body bg-white focus:outline-none focus:border-retro-teal text-sm" placeholder="john@acme.com" />
            </div>
            <div>
              <label className="block font-body font-bold text-xs mb-1">Phone</label>
              <input required type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full border-4 border-retro-brown rounded-xl p-2.5 font-body bg-white focus:outline-none focus:border-retro-teal text-sm" placeholder="(623) 000-0000" />
            </div>
          </div>
          <div className="pt-4">
            <RetroButton variant="primary" className="w-full !py-3 !text-lg" disabled={isSubmitting}>
              {isSubmitting ? 'Reserving...' : 'Submit Pledge'}
            </RetroButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReserveModal;